import React from "react";
import { NAV_LINKS } from "./navConfig";

const NavMobilePanel = ({ onLinkClick }) => (
  <div
    data-testid="nav-mobile-panel"
    className="xl:hidden border-t border-white/5 nav-mobile-panel backdrop-blur-xl"
  >
    <div className="px-6 py-6 flex flex-col gap-4">
      {NAV_LINKS.map((l) => {
        if (l.variant === "dropdown") {
          return (
            <div
              key={l.id}
              data-testid={`nav-mobile-group-${l.id}`}
              className="flex flex-col gap-3"
            >
              <div className="text-[10px] tracking-[0.4em] uppercase text-gold/85 pt-2">
                {l.label}
              </div>
              {l.items.map((item) => {
                const isRoute = Boolean(item.route);
                return (
                  <a
                    key={item.id}
                    data-testid={`nav-mobile-link-${item.id}`}
                    href={isRoute ? item.route : `#${item.id}`}
                    onClick={(e) => {
                      if (!isRoute) e.preventDefault();
                      onLinkClick(item);
                    }}
                    className="pl-3 text-left text-sm tracking-[0.22em] uppercase text-themed-muted hover:text-gold border-l border-gold/20"
                  >
                    {item.label}
                  </a>
                );
              })}
            </div>
          );
        }
        const isRoute = Boolean(l.route);
        return (
          <a
            key={l.id}
            data-testid={`nav-mobile-link-${l.id}`}
            href={isRoute ? l.route : `#${l.id}`}
            onClick={(e) => {
              if (!isRoute) e.preventDefault();
              onLinkClick(l);
            }}
            className="text-left text-sm tracking-[0.22em] uppercase text-themed-muted hover:text-gold"
          >
            {l.label}
          </a>
        );
      })}
    </div>
  </div>
);

export default NavMobilePanel;
